export const alert_statuses = [{
  id: "backlog",
  title: "Backlog",
  color: "#757575",
  back: "#E3E3E3"
}, {
  id: "in_progress",
  title: "In progress",
  color: "#8F710A",
  back: "#FAEBB7"
}, {
  id: "in_review",
  title: "In review",
  color: "#2172E1",
  back: "#E0ECFF"
}, {
  id: "suspended",
  title: "Suspended",
  color: "#B75B15",
  back: "#FFF2E8"
}, {
  id: "blocked",
  title: "Blocked",
  color: "#DB333B",
  back: "#FFE5E7"
}, {
  id: "solved",
  title: "Solved",
  color: "#22863D",
  back: "#DEFBE6"
}];